/** Legacy Amenity Comparator
 * Because of the Bex Migration and compatibility with all of our LOBs we are moving away from the enum integer values that are mapped in
 * the BFF and transitioning to using the string values that return from the LSCS directly.
 */

enum AMENITY_LEGACY_MAPPING {
  pool = '7',
  freeParking = '14',
  freeBreakfast = '16',
  petsAllowed = '17',
  highSpeedInternet = '19',
  airConditioning = '27',
  allInclusive = '30',
  freeAirportTransport = '66',
  hotTub = '70',
  waterPark = '71',
  oceanView = '72',
  kitchen = '73',
  spaOnSite = '74',
  casino = '75',
  laundryFacility = '76',
  kitchenKitchenette = '77',
  hotSpring = '78',
}

export function amenityLegacyEquals(amenity1: any, amenity2: any): boolean {
  if (isNaN(amenity1)) {
    if (isNaN(amenity2)) {
      return amenity1 === amenity2;
    }

    // @ts-ignore
    return AMENITY_LEGACY_MAPPING[amenity1] === amenity2;
  } else if (isNaN(amenity2)) {
    // @ts-ignore
    return AMENITY_LEGACY_MAPPING[amenity2] === amenity1;
  }

  return amenity1 === amenity2;
}
